import { MenuGroup } from '../models/application-menu.model';

export const sidebarStaticMenuCustomAdmin: MenuGroup[] = [
  {
    name: 'Master Data',
    groupChildren: [
      {
        name: 'Software Setting',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        link: '/software-setting',
        children: [
          {
            name: `Master Login dan User`,
            link: '/software-setting/master-login',
          },
          {
            name: 'Master Loket Antrian',
            link: '/software-setting/master-loket-antrian',
          },
          {
            name: 'Master Loket Panggilan',
            link: '/software-setting/master-loket-panggilan',
          },
          {
            name: 'Master Jenis Loket',
            link: '/software-setting/master-jenis-loket',
          },
          {
            name: 'Setting',
            link: '/software-setting/setting-menu/data-klinik/info',
          },
        ],
      },
      {
        name: 'Master Keuangan',
        icon: './assets/media/svg/icons/Periksa/master-keuangan-icon.svg',
        link: '/master-keuangan',
        children: [
          {
            name: 'Manage Metode Pembayaran',
            link: '/master-keuangan/manage-metode-pembayaran',
          },
          {
            name: 'Manage Biaya Tambahan Kasir',
            link: '/software-setting/manage-biaya-tambahan-kasir',
          },
        ],
      },
      {
        name: 'Master Klinik',
        icon: './assets/media/svg/icons/Periksa/master-klinik-icon.svg',
        link: '/master-klinik',
        children: [
          {
            name: 'Instalasi',
            link: '/master-klinik/instalasi',
          },
          {
            name: 'Poli Klinik',
            link: '/master-klinik/poli-klinik',
          },
          {
            name: 'Cuti Disable',
            link: '/master-klinik/cuti-disable',
          },
          {
            name: 'Banner',
            link: '/master-klinik/banner',
          },
        ],
      },
      {
        name: 'Master Logistik',
        icon: './assets/media/svg/icons/Periksa/master-logistik-icon.svg',
        link: '/master-logistik',
        children: [
          {
            name: 'Gudang',
            link: '/master-logistik/gudang',
          },
          {
            name: 'Rak Gudang',
            link: '/master-logistik/rak-gudang',
          },
          {
            name: 'Kategori Barang',
            link: '/master-logistik/kategori-barang',
          },
        ],
      },
      {
        name: 'Master Medis',
        icon: './assets/media/svg/icons/Periksa/master-medis-icon.svg',
        link: '/master-medis',
        children: [
          {
            name: 'Manage Tarif Odontogram',
            link: '/master-medis/tarif-odontogram',
          },
        ],
      },
      {
        name: 'Procurement',
        icon: './assets/media/svg/icons/Periksa/logistik-icon.svg',
        link: '/procurement',
        children: [
          {
            name: 'Manage Supplier',
            link: '/procurement/manage-supplier',
          },
        ],
      },

      {
        name: 'Master User',
        icon: './assets/media/svg/icons/Periksa/master-user-icon.svg',
        link: '/master-user',
        children: [
          {
            name: 'Cuti',
            link: '/master-user/cuti',
          },
          {
            name: 'Unit Kerja',
            link: '/master-user/unit-kerja',
          },
        ],
      },
    ],
  },
];
